import getUniqueKey from "@/helpers/getUniqueKey";

export default function Leerkracht(options, type) {
  // convert subgroepen to samengestelde_groepen
  if (options.subgroepen) {
    options.groepen = { ...options.groepen, samengestelde_groep: [] };
    if (options.subgroepen) {
      options.subgroepen.groep.forEach((subgroup) => {
        options.groepen.samengestelde_groep.push(subgroup);
      });
    }
  }

  if (type === "json") {
    this.key = { key: options.key || getUniqueKey() };
  } else {
    this.key = { key: options.key.key };
  }

  this.achternaam = options.achternaam;
  this.roepnaam = options.roepnaam || options.voornaam;
  this.emailadres = options.emailadres;
  this.voorletters = options.voorletters;
  this.voorvoegsel = options.voorvoegsel;
  this.groepen = options.groepen || { groep: [] };
}
